import { Card, CardHeader, CardTitle, CardContent } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { Link } from "react-router";

const NotFoundPage = () => {
  return (
    <div className="flex flex-col justify-center items-center min-h-screen bg-background">
      <Card className="w-full max-w-md mx-auto p-8 shadow-xl border-none bg-background/80 backdrop-blur-md text-center relative">
        <div className="flex justify-center mb-4 select-none">
          <img
            src="/smooth-floating-blob.gif"
            alt="Floating blob animation"
            className=" drop-shadow-2xl mx-auto animate-pulse pointer-events-none select-none"
            aria-hidden="true"
            draggable="false"
          />
        </div>
        <CardHeader className="px-0">
          <CardTitle className="text-6xl font-black text-chen-900 tracking-tight mb-4">404</CardTitle>
        </CardHeader>
        <CardContent className="px-0">
          <div className="text-lg md:text-xl text-muted-foreground mb-8">
            Oops, nothing to see here.
            <br />
            The page you’re looking for doesn’t exist or got zapped into the ether.
          </div>
          <Button asChild size="lg" variant="default" className="text-lg px-8 py-6 rounded-xl shadow-md">
            <Link to="/" tabIndex={0} aria-label="Go to homepage">
              Go Home
            </Link>
          </Button>
        </CardContent>
      </Card>
    </div>
  );
};

export default NotFoundPage;
